export function sortExploreTeam(decks) {
  // sort decks by no
  decks.sort((a, b) => {
    return a[0] - b[0]
  })
  let myDeck: any = []
  let i = 0
  decks.forEach(x => {
    myDeck[i] = {
      no: x[0],
      item: x[1],
    }
    i++
  })

  return myDeck
}
